<script setup lang="ts">
    const { horizontal = false } = defineProps<{
        horizontal?: boolean;
    }>();
</script>

<template>
    <div
        :class="{
            'teaser-card-skeleton': true,
            'teaser-card-skeleton--horizontal': horizontal
        }"
    >
        <div class="loading-skeleton image"></div>
        <div class="content">
            <div class="loading-skeleton --slim-margin --subheadline --full-width"></div>
            <div class="loading-skeleton --slim-margin --line --full-width"></div>
            <div class="loading-skeleton --slim-margin --line --medium"></div>
            <div class="loading-skeleton --slim-margin loading-button"></div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    @import '~/assets/scss/basics/loading-skeleton.scss';
    @import '~/assets/scss/academy/teaser-layout.scss';

    .teaser-card-skeleton {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 25rem;
        min-height: 427px; // Figma card height
        border-radius: var(--border-radius-s);
        overflow: hidden;
        padding: var(--spacing);

        .image {
            width: 100%;
            aspect-ratio: 16 / 9;
            margin-bottom: var(--spacing);
        }

        .content {
            display: flex;
            flex-direction: column;
            flex: 1;
        }

        .loading-button {
            width: 100%;
            height: 2.5rem;
            margin-top: auto;
        }

        .loading-skeleton.--medium {
            width: 70%;
        }
    }

    .teaser-card-skeleton--horizontal {
        max-width: inherit;
        min-height: auto;

        @include teaser-horizontal-layout {
            flex-direction: row;
            gap: var(--spacing);
            padding: var(--spacing--2);

            .image {
                width: 25rem;
                flex-shrink: 0;
                aspect-ratio: 16 / 9;
                margin-bottom: 0;
            }

            .content {
                flex: 1;
                justify-content: center;
            }

            .loading-button {
                max-width: 40%;
            }
        }
    }
</style>
